const SAFE_COEF = 1e5;

export function calculateTotal(amount?: string | null, quantity?: number | null): number | undefined {
  if (!amount || !quantity) {
    return;
  }

  const parsedAmount = parseFloat(amount);
  if (isNaN(parsedAmount)) {
    return;
  }

  /**
   * To avoid floating point precision issues during multiplication,
   * we scale the result to an integer and then scale it back.
   */
  return Math.round(parsedAmount * quantity * SAFE_COEF) / SAFE_COEF;
}
